import React from "react";
import PropTypes from "prop-types";
import { Form, Message } from "semantic-ui-react";
import FormInput from "../../Form/FormInput";
import { Button } from "../../";
import styles from "./styles.less";
import cx from "classnames";

class ContactUsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
      requestType: this.props.requestType
    };
  }

  onSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    onSubmit({ ...this.state });
  };

  onFirstNameChange = value => {
    this.setState({ firstName: value });
  };
  onLastNameChange = value => {
    this.setState({ lastName: value });
  };
  onEmailChange = value => {
    this.setState({ email: value });
  };
  onPhoneChange = value => {
    this.setState({ phone: value });
  };
  onMsgChange = value => {
    // const fixedValue = value.replace(/\r?\n/g, "<br />");
    this.setState({ message: value });
  };

  getEmailValidtionMsg = () => {
    const { titles } = this.props;
    let result = "";
    result = `${titles.ThisFieldIsMust},
    ${titles.ThisFieldNeedToBeEmailFormat}.`;
    return result;
  };

  getMessageContent = () => {
    const { submitingStatus, titles } = this.props;
    let result = "";
    if (submitingStatus && submitingStatus.error)
      result = titles.ContactFormErrorMessage;

    return result;
  };

  renderForm = () => {
    const { titles, submitingStatus, isMobileView } = this.props;
    return (
      <Form
        className={styles.form}
        onSubmit={this.onSubmit}
        loading={submitingStatus && submitingStatus.loading}
        error={submitingStatus && submitingStatus.error}
      >
        <Form.Group widths="equal">
          <FormInput
            label={titles.FirstName}
            onChange={this.onFirstNameChange}
            titles={titles}
            required
            customValidation={titles.ThisFieldIsMust}
          />
          <FormInput
            label={titles.LastName}
            onChange={this.onLastNameChange}
            titles={titles}
            required
            customValidation={titles.ThisFieldIsMust}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <FormInput
            label={titles.Email}
            onChange={this.onEmailChange}
            titles={titles}
            type="email"
            required
            customValidation={this.getEmailValidtionMsg()}
          />
          <FormInput
            label={titles.Phone}
            onChange={this.onPhoneChange}
            titles={titles}
            phone
            required
            customValidation={titles.ThisFieldIsMust}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <FormInput
            label={titles.Message}
            onChange={this.onMsgChange}
            titles={titles}
            textarea
          />
        </Form.Group>

        <Message
          visible={submitingStatus && submitingStatus.error}
          error
          content={this.getMessageContent()}
        />
        <Button
          isSubmit={true}
          className={cx(styles.submitFormBtn, {
            [styles.mobileView]: isMobileView
          })}
          title={titles.Send}
        />
      </Form>
    );
  };

  render() {
    return this.renderForm();
  }
}

ContactUsForm.propTypes = {
  submitingStatus: PropTypes.object,
  onSubmit: PropTypes.func,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  requestType: PropTypes.string
};

export default ContactUsForm;



// WEBPACK FOOTER //
// ./src/components/common/ContactUs/ContactUsForm/ContactUsForm.js